import apiClient from './apiClient';


class S3Service {
  async uploadFile(file, folder = 'temp') {
    return await apiClient.uploadFile(file, folder);
  }

  async deleteFile(key) {
    return await apiClient.deleteFile(key);
  }

  async getSignedUrl(key, expiresIn = 3600, filename = null) {
    return await apiClient.getSignedUrl(key, expiresIn, filename);
  }

  async downloadFileAsBlob(key, filename = null) {
    return await apiClient.downloadFileAsBlob(key, filename);
  }

  async uploadContractPDF(file, contractId) {
    return await apiClient.uploadContractPDF(file, contractId);
  }

  async uploadProtocolPDF(file, contractId) {
    return await apiClient.uploadProtocolPDF(file, contractId);
  }
  async uploadOfferPDF(file, offerId) {
    return await apiClient.uploadOfferPDF(file, offerId);
  }

  async uploadRevisedOfferPDF(file, offerId) {
    return await apiClient.uploadRevisedOfferPDF(file, offerId);
  }

  async uploadJobCommissionDocument(file, jobId) {
    return await apiClient.uploadJobCommissionDocument(file, jobId);
  }

  async uploadJobFirstPhaseDocument(file, jobId) {
    return await apiClient.uploadJobFirstPhaseDocument(file, jobId);
  }
}

export default new S3Service();
